
import './viewAllOnboarded.css';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS } from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { Box, CardContent, Card, Typography, Button, Tooltip, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Fab } from '@mui/material';
import { PROD } from '../../../common/constants';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import Accordion from 'react-bootstrap/Accordion';
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { RemoveRedEyeIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ViewAllOnboarding() {
  const { t } = useTranslation();
  const [stakeHolders, setStakeHolders] = useState();
  const [viewOnboarding, setViewOnboarding] = useState();
  const [userID, setUserId] = useState();
  const [statuss, setStatus] = useState();
  useEffect(() => {
    setUserId(location.state.userid);
    setStatus(location.state.status);

  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state.userid;
  const status = location.state.status;
  useEffect(() => {
    if (userId && status) {
      getAllOnboarding();
    }
  }, [userId]);
  const onView = (urnSelected, stakeholderType, growerSubCategory) => {
    const userData = {
      "urnSelected": urnSelected,
      "userId": userId

    }
    if (stakeholderType === "Transporter") {
      navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
    }
    else if (stakeholderType === "HIT") {
      navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
    }
    else if (stakeholderType === "LLE") {
      navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
    }
    else if (stakeholderType === "Interim Storage Operator") {
      navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected } });
    }
    else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
      navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected } });
    }
    else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
      navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected } });
    }
    else if (growerSubCategory === "Forest") {
      navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected } });
    }
    else {
      // navigate("/registrationHome/dashboard/onView", { state: { data: userData } });
    }
  }
  function getAllOnboarding() {
    apiClient
      .post(GET_APPLICATION_LIST,
        {
          "userID": userId,
          "status": status,
          "regStatus": ''
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setViewOnboarding(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const lastFiveDigitsComparator = (a, b, column) => {
    const getLastFiveDigits = (value) => {
      const lastFive = value.substring(value.length - 5);
      return lastFive;
    };
    return getLastFiveDigits(a) - getLastFiveDigits(b);
  };
  const OnboardingArray = viewOnboarding?.scrutinyWorkFlowStepDetails;

  const columns = [
    {
      field: 'id', headerName: 'S.No', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.urn) + 1
    },
    {
      field: 'name', headerName: t('preReg.name'), width: 180,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
          {params.value}
        </div>
      ),
      valueGetter: (params) => params.value
    },
    { field: 'urn', headerName: 'URN', width: 200, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
    { field: 'stakeholderSubCategory', headerName: 'Stakeholder Subcategory', width: 200 },
    { field: 'status', headerName: 'Status', width: 130 },
    { field: 'totalQuantity', headerName: 'Total Quantity (in MT)', width: 140, type: "number" },
    { field: 'committedQuantity', headerName: 'Committed Quantity (in MT)', width: 140, type: "number" },
    {
      field: 'action', headerName: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="view">
            <IconButton
              color="primary"
              onClick={() => onView(cellValues?.row?.urn, cellValues?.row?.stakeholderType, cellValues?.row?.stakeholderSubCategory)}
            >
              <RemoveRedEyeIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },

  ];

  return (
    <>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG40</p>}

      <Card>

        <CardContent>
          <div style={{ display: "inline-flex" }}>
            <Typography variant="h4" sx={{ mb: 2 }}>
              <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'>
                <KeyboardArrowLeftRounded />
              </Fab>
            </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div className="hitDetailsText">{status === "Approved" ? "Total Onboarded" : "Total Rejections"}</div>
          </div>
          {OnboardingArray && <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
            <DataGrid
              sx={{
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal"
                },
                "& .MuiDataGrid-columnHeader": {
                  height: "unset !important"
                },
                "& .MuiDataGrid-columnHeaders": {
                  maxHeight: "168px !important"
                },
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
              }}
              getRowHeight={() => 'auto'}
              rows={OnboardingArray}
              columns={columns}
              pageSize={10}
              getRowId={(row) => row.urn}
              components={{ Toolbar: QuickSearchToolbar }}
            />
          </Box>}
        </CardContent>
      </Card>
    </>
  );
}
export default ViewAllOnboarding;

